'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFiberDvr = function MdFiberDvr(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 19.1v-1.6c0-1.4-1.1-2.5-2.5-2.5h-5.9v10h2.5v-3.4h2l1.4 3.4h2.5l-1.5-3.5c0.9-0.4 1.5-1.3 1.5-2.4z m-14 5.9l3-10h-2.5l-1.7 5.7-1.7-5.7h-2.5l2.9 10h2.5z m-7.6-2.5v-5c0-1.4-1.1-2.5-2.5-2.5h-5.9v10h5.9c1.4 0 2.5-1.1 2.5-2.5z m21.6-17.5c1.9 0 3.4 1.5 3.4 3.4v23.2c0 1.8-1.5 3.4-3.4 3.4h-30c-1.9 0-3.4-1.6-3.4-3.4v-23.2c0-1.9 1.5-3.4 3.4-3.4h30z m-27.5 12.5h3.4v5h-3.4v-5z m21.6 0h3.4v1.6h-3.4v-1.6z' })
        )
    );
};

exports.default = MdFiberDvr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/fiber-dvr.js
// module id = 2854
// module chunks = 0